import type { ReactNode } from 'react';

import { Col, Row } from '../../../Layout';
import type { CellComponent, RowDefinition } from '../../types';

const Columns = ({
  cols,
  renderComponent
}: {
  cols: Array<CellComponent>;
  renderComponent: (definition: CellComponent) => ReactNode;
}) => {
  const anyVisible = cols?.some((cell) => cell.visible);
  const toKebabCase = (value: string) => value.replace(/([a-z0-9])([A-Z])/g, '$1-$2').toLowerCase();

  if (!anyVisible) {
    return <div className="d-none">{cols.map((cell) => renderComponent(cell))}</div>;
  }

  return (
    <>
      {cols.map((cell: CellComponent) => {
        return (
          <Col lg={6} xl={6} md={6} key={cell.code}>
            <div
              className={`card mb-1 mt-2 card-tax-return-cell ${cell.cellPurpose ? `purpose-${toKebabCase(cell.cellPurpose)}` : ''}`}>
              <div className="card-body px-2 py-1">
                <div
                  className={`d-flex flex-column h-100 ${cell.visible ? '' : 'invisible'}`}
                  style={{ flex: '1' }}>
                  <div className="d-flex gap-3 h-100">
                    <div className="d-flex align-items-center">
                      <span className="cell-code">{cell.code}</span>
                    </div>

                    <div className="d-flex flex-grow-1 align-items-end h-100">
                      <div className="w-100">{renderComponent(cell)}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Col>
        );
      })}
    </>
  );
};

export const RowComponent = ({
  row,
  renderComponent
}: {
  row: RowDefinition;
  renderComponent: (definition: CellComponent) => ReactNode;
}) => {
  return (
    <Row key={row.id}>
      <Columns cols={row.cols} renderComponent={renderComponent} />
    </Row>
  );
};
